import { render, staticRenderFns } from "./greeho.vue?vue&type=template&id=7648a717&"
import script from "./greeho.vue?vue&type=script&lang=js&"
export * from "./greeho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports